var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBarChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.5H2.6C2.03995 5.5 1.75992 5.5 1.54601 5.60899C1.35785 5.70487 1.20487 5.85785 1.10899 6.04601C1 6.25992 1 6.53995 1 7.1V17.9C1 18.4601 1 18.7401 1.10899 18.954C1.20487 19.1422 1.35785 19.2951 1.54601 19.391C1.75992 19.5 2.03995 19.5 2.6 19.5H7M7 19.5H13M7 19.5L7 3.1C7 2.53995 7 2.25992 7.10899 2.04601C7.20487 1.85785 7.35785 1.70487 7.54601 1.60899C7.75992 1.5 8.03995 1.5 8.6 1.5L11.4 1.5C11.9601 1.5 12.2401 1.5 12.454 1.60899C12.6422 1.70487 12.7951 1.85785 12.891 2.04601C13 2.25992 13 2.53995 13 3.1V19.5M13 9.5H17.4C17.9601 9.5 18.2401 9.5 18.454 9.60899C18.6422 9.70487 18.7951 9.85785 18.891 10.046C19 10.2599 19 10.5399 19 11.1V17.9C19 18.4601 19 18.7401 18.891 18.954C18.7951 19.1422 18.6422 19.2951 18.454 19.391C18.2401 19.5 17.9601 19.5 17.4 19.5H13",
    stroke: "#02222B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarChart);
export default __webpack_public_path__ + "static/media/icon_barChart.806140a75b0f6e4950168f887152ab57.svg";
export { ForwardRef as ReactComponent };